import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface ReopenReceiptRequest {
  receiptIds: number[];
}

interface UseReopenReceiptMutationOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useReopenReceiptMutation = ({ onSuccess, onError }: UseReopenReceiptMutationOptions = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (receiptIds: number[]) => {
      const response = await axiosInstance.post(api.reopenReceipt, receiptIds);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate receipt queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: queryKeys.receipt.root,
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useReopenReceiptMutation;
